import { Grid, Typography, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import { useHistory, useLocation } from 'react-router-dom'
import { ButtonView } from '../../../control/button/button'
import Switch from '@material-ui/core/Switch'
import { useSettingDocument, SearchDocumentRequest } from '../../../services/um/useSettingDocument'
import useAuthenStore from '../../../stores/authen/authenStore'

type OrderProps = {
    index: number
    documentID: number
    nameTH: string
    nameEN: string
    shortNameTH: string
    shortNameEN: string
    code: string
    order: number
    docRequire: boolean
    reLoadData?: (param: SearchDocumentRequest) => void
}

const Order = ({
    index,
    documentID,
    nameTH,
    nameEN,
    shortNameTH,
    shortNameEN,
    code,
    order,
    docRequire,
    reLoadData,
}: OrderProps) => {
    const translate = useTranslate()
    const history = useHistory()
    const location = useLocation()

    const classes = useStyles()
    const { postDocRequire } = useSettingDocument()
    const authenStore = useAuthenStore()

    const onEdit = () => {
        history.push(`/settingDocument/${documentID}/edit`)
    }

    const onChangeDocRequire = async (props: any) => {
        const result = await postDocRequire({ documentID: documentID, order: order })

        if (result.status == 1) {
            const URL = new URLSearchParams(location.search)
            const submittedType = URL.get('submittedType')

            let param: SearchDocumentRequest = {
                userID: authenStore.profile.userId ?? 0,
                recID: authenStore.profile.irb,
                submittedTypeID: submittedType ? submittedType : '1',
            }

            reLoadData && reLoadData(param)
        }
    }

    return (
        <div className={classes.item} key={documentID}>
            <Grid container spacing={2} alignItems="center">
                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    <ButtonView className={classes.btnEdit} onClick={onEdit}>
                        {translate.get('BUTTON.EDIT')}
                    </ButtonView>
                </Grid>

                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name}>{translate.get('UM.SETTINGDOCUMENT.TABLE.no')}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{`${order}`}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={3} lg={3} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name}>
                            {translate.get('UM.SETTINGDOCUMENT.TABLE.nameTH')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameTH ?? '-'}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={3} lg={3} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name}>
                            {translate.get('UM.SETTINGDOCUMENT.TABLE.nameEN')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameEN ?? '-'}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={1} lg={1} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name}>
                            {translate.get('UM.SETTINGDOCUMENT.TABLE.code')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography noWrap>{code ?? '-'}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={1} lg={1} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name}>
                            {translate.get('UM.SETTINGDOCUMENT.TABLE.docRequire')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography noWrap>
                            <Switch size="small" checked={docRequire} onChange={() => onChangeDocRequire(docRequire)} />
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
const useStyles = makeStyles((theme) => ({
    item: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    icon: {
        marginRight: theme.spacing(1),
        width: 40,
        height: 40,
        backgroundColor: '#ece9e9',
        transition: '0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
    name: {
        fontWeight: 'bold',
    },
    btnEdit: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
    },
    multiLineEllipsis: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
}))

export default Order
